import React from "react";
import Title from "../layouts/Title";
import { projectOne, projectTwo, projectThree, ProjectFour } from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] dark:border-b-gray-600"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="flex flex-col md:flex-row flex-wrap items-center justify-center gap-6 xl:gap-14 w-full">
        <ProjectsCard
          title="ScholarDen"
          des="ScholarDen is a GRE preparation and USA scholarship platform offering AI-based study plans, CV and SOP builders, and smart tools to help students secure admissions and scholarships."
          src={ProjectFour}
          url="https://scholarden.com/"
          git=""
        />

        <ProjectsCard
          title="SKillPort"
          des="Create your professional portfolio with Skillport.The easiest way to present your skills, experience, and achievements in one place."
          src={projectOne}
          url="https://skillport.work/"
          git=""
        />
        <ProjectsCard
          title="Webstapler"
          des=" Organize and access your links, your way, Consume the web as a feed, 
          Listen to the web as a playlist, Share your web presence as a Bio          "
          src={projectTwo}
          url={null}
          git=""
        />
        <ProjectsCard
          title="Attendance system"
          des=" An efficient attendance system for streamlined record-keeping on cloud, built with cutting-edge technology for univerty in Next.js"
          src={projectThree}
          url="https://gpcjweb.vercel.app/"
          git=""
        />
      </div>
    </section>
  );
};

export default Projects;
